export default "__VITE_ASSET__BhaU6hko__"